export default "__VITE_ASSET__Bg3t6Gor__"